<template>
    <v-container>
        <v-card color="indigo lighten-5">
            <v-toolbar color="indigo" dark>
                <v-app-bar-nav-icon></v-app-bar-nav-icon>
                <v-toolbar-title>設定</v-toolbar-title>
                <v-spacer></v-spacer>
            </v-toolbar>

            <v-card-text>
                <!--
                <v-btn to="/favorites" color="success" block class="my-16 pa-9">
                    <h2>お気に入り設定</h2>
                </v-btn>
                <v-btn to="/chart-setting" color="success" block class="my-16 pa-9">
                    <h2>グラフ設定</h2>
                </v-btn>
                <v-btn to="/line-notify" color="success" block class="my-16 pa-9" v-show="dispLineNotify">
                    <h2>Line通知設定</h2>
                </v-btn>
                -->
                <v-btn to="/user" color="success" block class="my-16 pa-9">
                    <h2>アカウント設定</h2>
                </v-btn>
                <v-btn to="/devices" color="success" block class="my-16 pa-9">
                    <h2>デバイス設定</h2>
                </v-btn>
                <v-btn to="/pato-lamps" color="success" block class="my-16 pa-9">
                    <h2>パトランプ</h2>
                </v-btn>
                <v-btn to="/logout" color="warning" block class="my-16 pa-9">
                    <h2>ログアウト</h2>
                </v-btn>
            </v-card-text>
        </v-card>
        <div class="ma-5 pa-5"></div>
        <div class="ma-5 pa-5"></div>
        <div class="ma-5 pa-5"></div>
    </v-container>
</template>

<script>
export default {
    name: "Settings",
    //#######################################################
    data() {
        return {
            jwt: "",
            myInfo: [],
            dbSites: [],
            dbUsers: [],
            dispLineNotify: false,
        };
    },
    //#######################################################
    created: async function () {
        //====================================================
        this.jwt = this.$localStorage.get("jwt");
        if (!this.jwt) {
            this.$router.push({ name: "Login" });
            return;
        }
        this.myInfo = this.$jwt.decode(this.jwt);
        if (this.myInfo && this.myInfo.exp < this.$moment().unix()) {
            this.$router.push({ name: "Login" });
            return;
        }
        //---------------------------
        //this.getSites();
        //this.getUsers();
        //---------------------------
        window.scrollTo(0, 0);
    },
    //#######################################################
    methods: {
        //====================================================
        linkToOtherWindow(url) {
            window.open(url, "_blank");
        },
        //====================================================
        async getSites() {
            await this.axios({
                method: "GET",
                url: "/web/api/sites",
                //params: { "_order[sort_no]": "desc" },
                headers: { Authorization: "Bearer " + this.jwt },
                timeout: 30000,
            }).then((response) => {
                this.dbSites = response.data.json;
            });
        },
        //====================================================
        async getUsers() {
            await this.axios({
                method: "GET",
                url: "/web/api/users",
                //params: { "_order[sort_no]": "desc" },
                headers: { Authorization: "Bearer " + this.jwt },
                timeout: 30000,
            }).then((response) => {
                this.dbUsers = response.data.json;
                if (this.dbUsers[0]) {
                    if (this.dbUsers[0].line_notify_token) this.dispLineNotify = true;
                }
            });
        },
        //====================================================
    },
    //#######################################################
};
</script>
